import { DateRange } from "@tm/components"
import { useRecoilState } from "recoil"
import { useParams } from "react-router"
import { useCallback } from "react"
import { voucherListFilterAtom } from "../../../../../data/states/listFilters"
import { VoucherRouteParams } from "../../../../../business"

type Props = {
    onRedirectToVoucherList(): void
}

export function DateFilters({ onRedirectToVoucherList }: Props) {
    const params = useParams<VoucherRouteParams>()

    const [listFilters, setListFilter] = useRecoilState(voucherListFilterAtom(params.workTaskId))

    const onRangeChange = useCallback(
        (startDate: Date, endDate: Date) => {
            setListFilter((prev) => ({
                ...prev,
                startDate,
                endDate,
            }))
            onRedirectToVoucherList()
        },
        [onRedirectToVoucherList, setListFilter]
    )

    return <DateRange initialDate={{ startDate: listFilters.startDate, endDate: listFilters.endDate }} onRangeChange={onRangeChange} />
}
